import styled from 'styled-components'
import {
  calculateResponsiveSize,
  calculateMobileResponsiveSize,
  mediaMax,
} from 'styles/media-queries'

export const Button = styled.div`
  width: ${calculateResponsiveSize(21)};
  height: ${calculateResponsiveSize(21)};
  position: relative;
  transition: 0.5s;
  cursor: pointer;

  span {
    display: flex;
    background: var(--blue);
    width: ${calculateResponsiveSize(21)};
    height: ${calculateResponsiveSize(1)};
    position: absolute;
    top: ${calculateResponsiveSize(10)};
    transition: 0.5s;

    &:before {
      content: '';
      display: flex;
      width: ${calculateResponsiveSize(1)};
      height: ${calculateResponsiveSize(10)};
      position: absolute;
      left: ${calculateResponsiveSize(10)};
      transform: translateY(-100%);
      background: var(--blue);
      transition: 0.5s;
    }
    &:after {
      content: '';
      display: flex;
      width: ${calculateResponsiveSize(1)};
      height: ${calculateResponsiveSize(10)};
      position: absolute;
      left: ${calculateResponsiveSize(10)};
      background: var(--blue);
      transition: 0.5s;
    }
  }
  &.hover span,
  &:hover span {
    &:before {
      transform: translateY(calc(-100% + ${calculateResponsiveSize(8)}))
        rotate(-45deg) translateX(${calculateResponsiveSize(8)});
      height: ${calculateResponsiveSize(16)};
    }
    &:after {
      transform: translateY(calc(-100% + ${calculateResponsiveSize(8)}))
        rotate(45deg) translateX(${calculateResponsiveSize(8)});
      height: ${calculateResponsiveSize(16)};
    }
  }
  &.open {
    transform: rotate(45deg);
    &.hover span,
    &:hover span {
      &:before {
        transform: translateY(-100%);

        height: ${calculateResponsiveSize(10)};
      }
      &:after {
        transform: translateY(0%);
        height: ${calculateResponsiveSize(10)};
      }
    }
  }
  &.white {
    span {
      background: var(--light);
      &:before,
      &:after {
        background: var(--light);
      }
    }
  }
  &.down {
    transform: rotate(90deg);
  }
  &.left {
    transform: rotate(-180deg);
  }

  &.open-first {
    opacity: 0;
    cursor: default;
  }
  ${mediaMax('mobile')} {
    width: ${calculateMobileResponsiveSize(21)};
    height: ${calculateMobileResponsiveSize(21)};
    span {
      width: ${calculateMobileResponsiveSize(21)};
      height: ${calculateMobileResponsiveSize(1)};
      top: ${calculateMobileResponsiveSize(10)};

      &:before {
        width: ${calculateMobileResponsiveSize(1)};
        height: ${calculateMobileResponsiveSize(10)};
        left: ${calculateMobileResponsiveSize(10)};
      }
      &:after {
        width: ${calculateMobileResponsiveSize(1)};
        height: ${calculateMobileResponsiveSize(10)};
        left: ${calculateMobileResponsiveSize(10)};
      }
    }
    &.mob-no-anim span,
    &.hover span,
    &:hover span {
      &:before {
        transform: translateY(calc(-100% + ${calculateMobileResponsiveSize(8)}))
          rotate(-45deg) translateX(${calculateMobileResponsiveSize(8)});
        height: ${calculateMobileResponsiveSize(16)};
      }
      &:after {
        transform: translateY(calc(-100% + ${calculateMobileResponsiveSize(8)}))
          rotate(45deg) translateX(${calculateMobileResponsiveSize(8)});
        height: ${calculateMobileResponsiveSize(16)};
      }
    }
    &.open {
      &.hover span,
      &:hover span {
        &:before {
          height: ${calculateMobileResponsiveSize(10)};
        }
        &:after {
          height: ${calculateMobileResponsiveSize(10)};
        }
      }
    }
  }
`
